import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@/components/common/Tooltip';
import useSpeechstream from './useSpeechStream';
import LanguageSelectMenu from './LanguageSelectMenu';
import styles from './TextToSpeechButton.module.scss';

const TranslateButton = ({ locale }: { locale: Locale; }) => {
  const {
    loaded,
    selectedTranslationLanguage,
    setTranslationDestination,
    setTranslationSource,
    translateSelection,
    translationLanguages,
  } = useSpeechstream({ idToRead: '', locale });
  const [selectedLanguage, setSelectedLanguage] = useState(selectedTranslationLanguage());

  useEffect(() => {
    if (!loaded) return;

    const isEnglish = locale.toLowerCase() === 'en';
    setTranslationSource(isEnglish ? 'English' : 'Spanish');
    setTranslationDestination(isEnglish ? 'Spanish' : 'English');
    setSelectedLanguage(isEnglish ? 'Spanish' : 'English');
  }, [locale, loaded]);

  return (
    <>
      <Tooltip
        content="Translate selection"
        interactive={false}
        size="medium"
        theme="white"
      >
        <button
          aria-label="tts-translate"
          className={styles.ttsActionPlay}
          type="button"
          onClick={translateSelection}
        >
          <FontAwesomeIcon
            className="tw-text-tci-purple"
            icon={faGlobe}
          />
        </button>
      </Tooltip>
      <LanguageSelectMenu
        languages={translationLanguages()}
        selectedLanguage={selectedLanguage}
        setLanguage={language => (
          setTranslationDestination(language).then((res) => {
            setSelectedLanguage(res.englishDescription);
          })
        )}
      />
    </>
  );
};

export default TranslateButton;
